const STEPPER_WIDTH_BY_STEP_COUNT = {
  3: 'w-69',
  4: 'w-92',
  5: 'w-115',
} as const;

type StepperStepCount = keyof typeof STEPPER_WIDTH_BY_STEP_COUNT;

const DEFAULT_STEPPER_WIDTH = STEPPER_WIDTH_BY_STEP_COUNT[3];

export const getStepperWidth = (stepCount: number): string => {
  if (stepCount in STEPPER_WIDTH_BY_STEP_COUNT) {
    return STEPPER_WIDTH_BY_STEP_COUNT[stepCount as StepperStepCount];
  }

  return DEFAULT_STEPPER_WIDTH;
};
